<template>
  <v-main style="background-color: #b0bec5" >
    <v-container fluid style="max-width: 400px; height: 100%;" class="pa-0 d-flex">
      <vue-headful title="Team-Dashboard" description="Aimz"/>
        <div class="d-flex pa-0" style="width: 100%;">
          <v-col class="mt-3 d-flex align-stretch pa-0">
            <v-container fluid class="pa-0 pl-2 pt-2" id="dashboard_container">
              <week-paginator :date="date" class="mr-2 mb-2" base-url="/team_leaderboard/"></week-paginator>
              <v-card class="mr-2">
                <v-card-title>
                  <v-avatar class="ml-3" color="#eee">
                    <v-icon>mdi-trophy-outline</v-icon>
                  </v-avatar>
<!--                  dropdown-->
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn text v-bind="attrs" v-on="on" large class="ml-3 headline" style="text-transform: none">
                        <span>{{ selectedIdxName }}</span>
                        <v-icon class="ml-1 mr-n1">mdi-menu-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item-group v-model="selectedMenuItem" color="primary">
<!--                      index-->
                      <v-list-item key="index">
                        <v-list-item-title>Index</v-list-item-title>
                      </v-list-item>
                      <v-divider></v-divider>
<!--                      bereiche-->
                      <template v-for="(item, index) in bereiche">
                        <v-list-item :key="'b'+index">
                          <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
<!--                        actis-->
<!--                        <v-divider></v-divider>-->
<!--                        <v-list-item v-for="(a, index) in activities.filter(a=>a.bereich===item.b.bid)" :key="item.b.bid+'a'+index">-->
<!--                          <v-list-item-title>{{ a.name }}</v-list-item-title>-->
<!--                        </v-list-item>-->
<!--                        <v-divider></v-divider>-->
                      </template>
                      </v-list-item-group>
                    </v-list>
                  </v-menu>
                </v-card-title>
                <v-card-text>
                  <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
                  <v-list>
                    <v-list-item v-for="(member,i) in teamList" :key="member.id">
                      <v-list-item-avatar>
                        <v-avatar size="30" :color="getAvatarColor(i)" class="white--text">
                          {{i+1}}
                        </v-avatar>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="d-flex">
                          <div class="mt-3">{{member.name}}</div>
                          <v-spacer></v-spacer>
                          <div class="display-1">{{getScore(member)}}</div>
                        </v-list-item-title>
                        <v-divider></v-divider>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-container>
          </v-col>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import Vue from "vue";
import CenterContainer from "@/components/CenterContainer";
import Activities from "@/components/Activities";
import UserLib from "@/components/UserLib";
import Kinds from "@/components/Kinds";
import WeekPaginator from "@/components/Charts/WeekPaginator";
import {convertToInt} from "@/reusable/typeconversion";
import {ArrayX} from "@/reusable/array_extensions";
import ActivityLibrary from "@/components/ActivityLibrary";
const {DateTime} = require("luxon");

export default {
  name: 'TeamLeaderboard',
  components: {CenterContainer, WeekPaginator },
  data() {
    return {
      date: undefined,
      dateTime: undefined,
      isodate: undefined,
      subContentIndex: 0,
      week_index: {},
      activities: [],
      loading: false,
      // bereichNr: undefined,
      // b: undefined,
      // nextBereich: undefined,
      currentEmail: [],
      currentTreeNode: {},
      tree: [],
      teamList: [], // <-- flattened tree
      targets: undefined,
      bereiche: [
        //{title:'Index', param:'index'},
      ],
      selectedMenuItem:0,
      // actis: [
      //   {title:'Index', param:'index'},
      // ],
      selectedIdxId:'index',
      selectedIdxName:'Index',
    }
  },
  mounted() {
    if (this.$app.desktop)
      this.$app.show_drawer = true;
    this.routeChanged(this.$route);
    this.$nextTick(this.check_session)
  },
  beforeRouteUpdate(to, from, next) {
    //console.log("beforeRouteChanged", to);
    this.routeChanged(this.$route);
    next();
  },
  methods: {
    async check_session() {
      this.exit_if_not_logged_in();
      var user=await this.$backend.check_session();
      this.$app.save("user", user);
      this.exit_if_not_logged_in();
    },
    routeChanged(route) {
      if (route.params.date)
        this.date = new Date(route.params.date);
      else
        this.date = new Date(Date.now());
      var dateTime = DateTime.fromJSDate(this.date).setLocale("de");
      console.log({route, date: this.date, dateTime, weekday: dateTime.weekday});
      if (dateTime.weekday !== 1)
        dateTime = dateTime.startOf("week");
      console.log("after weekstart", {dateTime})
      this.dateTime = dateTime;
      this.date = dateTime.toJSDate();
      this.isodate = this.dateTime.toISODate();
      this.reload();
    },
    exit_if_not_logged_in() {
      if (!this.$app.is_logged_in) {
        this.$store.commit("set", {key: "intern", value: false});
        if (this.$route.path != "/")
          this.$router.replace("/");
        return;
      }
      this.$store.commit("set", {key: "intern", value: true});
    },
    async reload() {
      this.loading = true;
      var route = this.$route;
      if (route.params.date)
        this.date = new Date(route.params.date);
      else
        this.date = new Date(Date.now());
      var dateTime = DateTime.fromJSDate(this.date).setLocale("de");
      if (dateTime.weekday != 1)
        dateTime = dateTime.startOf("week");
      console.log("after weekstart", {dateTime})
      this.dateTime = dateTime;
      this.date = dateTime.toJSDate();
      this.isodate = this.dateTime.toISODate();
      this.tree = await this.$backend.get_team_tree(this.isodate) ?? [];
      console.log("team tree: " + this.tree);
      console.log("leaderboard: " + this.isodate);
      if (this.currentEmail.length===0 && this.tree && this.tree[0]) {
        this.currentEmail[0]=this.tree[0].id;
      }
      this.updateTeamList();
      //this.week_index = await this.$backend.get_object(Kinds.KIND_INDEX, );
      this.updateIndex();
      this.loading = false;
      //if (this.b) {
      var activities = await this.$backend.get_all_objects(Kinds.KIND_ACTIVITY);
      if (!activities)
        return;
      activities=ActivityLibrary.filterActivitiesByDate(activities, this.dateTime);
      activities.forEach(x=>x.sortKey||=0);
      this.activities = new ArrayX(activities).sortBy(a=>a.sortKey);
      this.loadMenuItems();
      //}
    },
    loadMenuItems(){
      this.bereiche=[];
      this.$app.bereiche.forEach(b=>{
        this.bereiche.push({title:b.name, b});
      });
    },
    async loadTargets() {
      this.targets=(await this.$backend.get_ziele(this.dateTime.year, this.currentEmail[0])||{});
    },
    updateTeamList() {
      this.teamList=[];
      var idxId=this.selectedIdxId;
      this.updateTeamListRecursive(this.tree);
      new ArrayX(this.teamList).sortBy(member=>{
        if (member.teamIndex) {
          return member.teamIndex['own/'+idxId] || 0;
        }
        if (member.index)
          return member.index[idxId] || 0;
        return 0;
      }, true);
    },
    updateTeamListRecursive(tree) {
      if (!tree)
        return;
      tree.forEach(x=>{
        this.teamList.push(x);
        this.updateTeamListRecursive(x.children);
      });
    },
    getScore(member) {
      var idxId=this.selectedIdxId;
      if (member.teamIndex) {
        return member.teamIndex['own/'+idxId] || 0;
      }
      return member.index[idxId] || 0;
    },
    getAvatarColor(index) {
      if (index==0)
        return "accent";
      if (index > 0 && index < 3)
        return "primary";
      return "#ccc";
    },
    updateIndex() {
      var email= this.currentEmail[0];
      if (!email) {
        this.week_index = {};
        return;
      }
      this.currentTreeNode = this.findCurrentTreeNode(this.tree, email);
      this.loadTargets();
    },
    findCurrentTreeNode(tree, email) {
      if (!tree)
        return undefined;
      for(let node of tree) {
        if (node.id===email) {
          return node;
        }
        var n=this.findCurrentTreeNode(node.children, email);
        if (n)
          return n;
      }
    },
    getIndex(treenode) {
      var n=treenode;
      if (n.index!==undefined) {
        return Math.round(n.index.index || 0);
      } else if (n.teamIndex!==undefined) {
        return Math.round(n.teamIndex["total/index"]||0);
      } else {
        return 0;
      }
    },
    isBereichShown(bereich) {
      return this.$app.isBereichShown(bereich);
    },
    // getBereich() {
    //   if (this.bereichNr === undefined)
    //     return undefined;
    //   return this.bereiche[this.bereichNr];
    // },
    // getNextBereich() {
    //   if (this.bereichNr === undefined)
    //     return undefined;
    //   return this.$app.getBereichName(this.bereiche[(this.bereichNr + 1) % this.bereiche.length]);
    // },
  },
  computed: {
    app() {
      return this.$app;
    },
    // bereiche() {
    //   return this.$app.bereiche.map(x=>x.bid);
    // },
    validActivities() {
      return this.activities.filter(a => a.name);
    },
    toOverview() {
      return '/team_dashboard/' + this.isodate;
    },
    // toNext() {
    //   return '/team_dashboard/' + this.isodate + '/' + ((this.bereichNr + 1) % this.bereiche.length);
    // }
  },
  watch: {
    $route(to, from) {
      this.routeChanged(to);
    },
    currentEmail: {
      deep: true,
      handler(n) {
        this.updateIndex();
      }
    },
    selectedMenuItem(n){
      if (n==0) {
        this.selectedIdxId = 'index';
        this.selectedIdxName = 'Index';
      }
      else {
        var b=this.$app.bereiche[n-1];

        this.selectedIdxId = b.bid;
        this.selectedIdxName = b.name;
      }
      this.updateTeamList();
    }
  }
}
</script>

<style>
.rb {
  border: red 1px solid;
}

.full_width {
  width: 100%;
}
</style>